import { API_BASE_URL } from './config';

interface User {
  email: string;
  name: string;
}

const googleAuth = async (token: string) => {
  const result = await fetch(`${API_BASE_URL}/auth/google`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  });

  if (!result.ok) {
    throw new Error('Failed to authenticate with Google');
  }

  return await result.json();
};

const validateToken = async (token: string): Promise<{ isValid: boolean, user: User }> => {
  const result = await fetch(`${API_BASE_URL}/auth/validate`, {
    method: 'POST',
    body: JSON.stringify({ token }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!result.ok) {
    throw new Error('Failed to validate token');
  }

  const { isValid, user: decoded } = await result.json();
  return { isValid, user: decoded };
};

export {
  googleAuth,
  validateToken,
};
